<template>
  <multiselect
    class="multiselect-supplier"
    v-model="selectedSupplier"
    :disabled="disabled"
    :placeholder="$t('supplier') + ' ' + $t('select') + '/suchen'"
    :options="filteredSuppliers"
    track-by="_id"
    :allow-empty="true"
    :deselectLabel="$t('deselectLabel')"
    selectLabel=""
    selectedLabel=""
    :internal-search="false"
    :close-on-select="true"
    :clear-on-select="false"
    :multiple="false"
    :show-labels="true"
    @search-change="onSupplierSearch"
  >
    <template slot="singleLabel" slot-scope="{ option }">
      <div v-if="option">
        {{ option.name }}
      </div>
    </template>
    <template slot="option" slot-scope="{ option }">
      <div>{{ option.name }}</div>
    </template>
    <template slot="noResult">
      <div>{{ $t('no_results') }}</div>
    </template>
  </multiselect>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import { FilterMatchMode } from 'primevue/api';

const SUPPLIER_PAGINATION = { skip: 0, pageSize: 20 };
const SUPPLIER_SORTING = { sortField: 'number', sortOrder: 1 };

/** Supplier selection with name search; loads the suppliers only when it can be changed. */
export default {
  name: 'MultiselectSuppliers',
  components: {
    Multiselect,
  },
  props: {
    supplier: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'supplier',
    event: 'select',
  },
  data() {
    return {
      filteredSuppliers: [],
      nameSearch: null,
    };
  },
  computed: {
    ...mapGetters(['getSuppliers']),

    selectedSupplier: {
      get() {
        return this.supplier;
      },
      set(supplier) {
        this.$emit('select', supplier);
      },
    },
  },
  methods: {
    ...mapActions(['fetchSuppliersPaginated']),

    async onSupplierSearch(rawQuery) {
      this.nameSearch = rawQuery.toLowerCase();
      await this.loadSupplierData();
    },

    async loadSupplierData() {
      await this.fetchSuppliersPaginated({
        pagination: SUPPLIER_PAGINATION,
        sorting: SUPPLIER_SORTING,
        filters: {
          number: { value: null, matchMode: FilterMatchMode.EQUALS },
          name: { value: this.nameSearch, matchMode: FilterMatchMode.CONTAINS },
        },
      });
      this.filteredSuppliers = this.getSuppliers;
      this.ensureSelectedSupplierIsAvailable();
    },

    ensureSelectedSupplierIsAvailable() {
      if (!this.supplier) {
        return;
      }
      const hasSelectedSupplier = this.filteredSuppliers.some(
        (filteredSupplier) => filteredSupplier._id === this.supplier._id
      );
      if (!hasSelectedSupplier) {
        this.filteredSuppliers = [this.supplier, ...this.filteredSuppliers];
      }
    },
  },
  async mounted() {
    if (!this.disabled) {
      await this.loadSupplierData();
    }
  },
};
</script>
